import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormTypePrecodedText } from './FormTypePrecodedText';
import { DeleteTypePrecodedText } from './DeleteTypePrecodedText';
import { Dialog } from 'primereact/dialog';


export const ModalTypePrecodedText = (props) => {
    const { modal, toggle, loading, method, name, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete, data, data2, changeOrder, arrayPrecod, changeArrayPrecod } = props;
    const modalTitle =
    method === 'create'
        ? 'Creación de tipo de texto precodificado'
        : method === 'update'
            ? 'Actualización de tipo de texto precodificado'
            : 'Eliminar tipo de texto precodificado';

    return (
       <Dialog
            header={modalTitle}
            visible={modal}
            modal
            closable={true}
            onHide={toggle}
            className="tiny-dialog"
            style={{ width: '45vw', minWidth: '400px' }}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
        >
            {method === 'create' ? (
                <FormTypePrecodedText
                    button="Crear texto precodificado"
                    {...{ toggle, loading, name, handleInputChange, validaciones, data, method, methodAction: saveCreate }}
                />
            ) : method === 'update' ? (
                <FormTypePrecodedText
                    button="Actualizar texto precodificado"
                    {...{
                        toggle,
                        loading,
                        name,
                        handleInputChange,
                        validaciones,
                        data,
                        method,
                        data2,
                        changeOrder,
                        arrayPrecod,
                        changeArrayPrecod,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeleteTypePrecodedText {...{ toggle, name, saveDelete }} />
            )}
        </Dialog>
    )
}
